export default "__VITE_ASSET__CkgS95fS__"